import notificationSound from "../assets/notification.mp3";

const audio = new Audio(`${notificationSound}`);

const playNotificationSound = () => {
  // play() rejects, rather than throws, when the browser blocks sound until the coach has used the page.
  const playing = audio.play();
  if (playing && playing.catch) playing.catch(() => console.warn("The user must first interact with the browser"));
};

// The push service worker asks one window of the app to play the alert for each push, also when its tab is in the
// background (nutivate-coaches#41).
export const startPushSound = () => {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "nutivate:push") playNotificationSound();
  });
};

export default playNotificationSound;
